import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import jwt_decode from 'jwt-decode';
import { Observable, share, tap } from 'rxjs';

import { environment } from '../../../environments/environment';
import { User } from '../../modules/user/models/user';
import { AuthResDto } from '../dto/auth-res.dto';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  API_BASE = `${environment.api}`;
  TOKEN_STORAGE_KEY = 'id_token';

  loadedUser: User | undefined;

  constructor(private http: HttpClient) {
  }

  login(username: any, password: any) {
    return this.http.post<AuthResDto>(`${this.API_BASE}/auth/login`, { username, password })
      .pipe(
        tap(res => this.setSession(res)),
        share()
      );
  }

  private setSession(authRes: AuthResDto) {
    const decoded = jwt_decode(authRes.access_token);
    localStorage.setItem(this.TOKEN_STORAGE_KEY, authRes.access_token);
  }

  logout() {
    localStorage.removeItem(this.TOKEN_STORAGE_KEY);
    Sentry.setUser(null);
  }

  public isLoggedIn() {
    return !this.isTokenExpired();
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }

  isTokenExpired() {
    const token = this.getGwtToken();

    if (!token) {
      return true;
    }

    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }

  getGwtToken(): string | null {
    return localStorage.getItem(this.TOKEN_STORAGE_KEY);
  }

  loadUserData(): Observable<User> {
    return this.http.get<User>(`${this.API_BASE}/auth/profile`);
  }

  init(): Observable<any> {
    return this.http.get<User>(`${this.API_BASE}/auth/profile`).pipe(
      tap(usr => {
        this.loadedUser = usr;
        Sentry.setUser({ id: String(usr.id), username: usr.name, email: usr.email });
      }),
      share()
    );
  }
}
